import { Button, ButtonGroup, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import { addtrip,editTrip } from "../../redux/features/trip.features";
 

const initialValues = {  
  tripName:"", startDate:"",endDate:"",fromCountry:"",toCountry:"",expense:"",cities:"",status:""
};

const TripEntry = (props) => {
  const dispatch = useDispatch()
  const [values, setValues] = useState(initialValues);

  useEffect(()=>{

    if(props.editMod){
      console.log(props.data)
      setValues(props.data)
    }

  },[])
  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  return (
    <div className="row">
       
      <div className="col-12">
        <div className="card">
          <div className="row card__body">
            <div className="col-6">
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="Trip id"
                defaultValue=""
                color="warning"
                margin="dense"
                name="tripId"
                value={values.tripId}
                
                onChange={handleChange}
              />
 
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="tripName"
                placeholder="tripName..."
                name="tripName"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.tripName}
              />

              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                
                id="outlined-required"
                label="startDate"
                placeholder="startDate"
                defaultValue=""
                color="warning"
                name="startDate"
                value={values.startDate}
                onChange={handleChange}
              />
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                
                id="outlined-required"
                label="endDate"
                placeholder="endDate"
                defaultValue=""
                color="warning"
                name="endDate"
                value={values.endDate}
                onChange={handleChange}
              />
          
            </div>
            <div className="col-6">
              <CustomSelectBox
                items={["Sri Lanka", "Singapore", "Tanzania", "USA", "UK", "Madagascar"]}
                onChange={handleChange}
                title="fromCountry"
                name="fromCountry"
                value={values.fromCountry}
              />
              <CustomSelectBox
                items={["Sri Lanka", "Singapore", "Tanzania", "USA", "UK", "Madagascar"]}
                onChange={handleChange}
                title="toCountry"
                name="toCountry"
                value={values.toCountry}
              />

              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="expense"
                placeholder="expense"
                name="expense"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.expense}
              />
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                
                id="outlined-required"
                label="cities"
                placeholder="cities"
                name="cities"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.cities}
              />
          
                <CustomSelectBox
                items={["Active", "DeActive"]}
                onChange={handleChange}
                title="Status"
                name="status"
                value={values.status}
              />
              <div style={{marginBottom:150}}></div>
              
              <ButtonGroup
               
                fullWidth
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button onClick={props.cancel} color="warning">Cancel</Button>
{
                
                props.editMod ? (<Button onClick={e=>dispatch(editTrip(values))} color="secondary">Edit Trip info</Button>) :(<Button onClick={e=>dispatch(addtrip(values))} color="success">Save</Button>)
}
              </ButtonGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripEntry;
